export const asutusedData = {
    "326": {
        "aadress": "Pärnu mnt. 326",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.683237,
                        59.388295
                    ],
                    [
                        24.683232,
                        59.388294
                    ],
                    [
                        24.683161,
                        59.38828
                    ],
                    [
                        24.682933,
                        59.388233
                    ],
                    [
                        24.682976,
                        59.38818
                    ],
                    [
                        24.683047,
                        59.388195
                    ],
                    [
                        24.683111,
                        59.388111
                    ],
                    [
                        24.682583,
                        59.388001
                    ],
                    [
                        24.682622,
                        59.387952
                    ],
                    [
                        24.682674,
                        59.387886
                    ],
                    [
                        24.683387,
                        59.388033
                    ],
                    [
                        24.683384,
                        59.388037
                    ],
                    [
                        24.683394,
                        59.388039
                    ],
                    [
                        24.683407,
                        59.388044
                    ],
                    [
                        24.683416,
                        59.388052
                    ],
                    [
                        24.683418,
                        59.38806
                    ],
                    [
                        24.683416,
                        59.388068
                    ],
                    [
                        24.683411,
                        59.388074
                    ],
                    [
                        24.683438,
                        59.388082
                    ],
                    [
                        24.683404,
                        59.388122
                    ],
                    [
                        24.683379,
                        59.388117
                    ],
                    [
                        24.683237,
                        59.388295
                    ]
                ]
            ]
        }
    },
    "Mefisto baar": {
        "aadress": "Sakala 11",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.748406,
                        59.431668
                    ],
                    [
                        24.748218,
                        59.431764
                    ],
                    [
                        24.748006,
                        59.431655
                    ],
                    [
                        24.748199,
                        59.431557
                    ],
                    [
                        24.748299,
                        59.431608
                    ],
                    [
                        24.748278,
                        59.431619
                    ],
                    [
                        24.748309,
                        59.431635
                    ],
                    [
                        24.74833,
                        59.431624
                    ],
                    [
                        24.748411,
                        59.431666
                    ],
                    [
                        24.748406,
                        59.431668
                    ]
                ]
            ]
        }
    },
    "Silva baar": {
        "aadress": "Raudtee 64",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.681695,
                        59.386106
                    ],
                    [
                        24.681642,
                        59.386142
                    ],
                    [
                        24.681623,
                        59.386154
                    ],
                    [
                        24.681526,
                        59.38622
                    ],
                    [
                        24.681421,
                        59.386291
                    ],
                    [
                        24.68135,
                        59.386264
                    ],
                    [
                        24.681378,
                        59.386246
                    ],
                    [
                        24.681124,
                        59.386152
                    ],
                    [
                        24.681125,
                        59.386151
                    ],
                    [
                        24.68115,
                        59.386133
                    ],
                    [
                        24.681035,
                        59.386089
                    ],
                    [
                        24.681071,
                        59.386065
                    ],
                    [
                        24.68106,
                        59.386059
                    ],
                    [
                        24.681057,
                        59.386057
                    ],
                    [
                        24.681053,
                        59.386042
                    ],
                    [
                        24.681067,
                        59.386032
                    ],
                    [
                        24.681068,
                        59.386031
                    ],
                    [
                        24.68107,
                        59.386031
                    ],
                    [
                        24.68109,
                        59.386023
                    ],
                    [
                        24.681132,
                        59.386029
                    ],
                    [
                        24.681169,
                        59.386004
                    ],
                    [
                        24.681264,
                        59.385938
                    ],
                    [
                        24.681264,
                        59.385939
                    ],
                    [
                        24.681381,
                        59.385986
                    ],
                    [
                        24.681332,
                        59.386023
                    ],
                    [
                        24.68135,
                        59.386029
                    ],
                    [
                        24.681352,
                        59.38603
                    ],
                    [
                        24.681354,
                        59.386031
                    ],
                    [
                        24.681427,
                        59.386056
                    ],
                    [
                        24.681469,
                        59.38603
                    ],
                    [
                        24.68147,
                        59.386029
                    ],
                    [
                        24.681472,
                        59.386028
                    ],
                    [
                        24.681485,
                        59.38602
                    ],
                    [
                        24.681507,
                        59.386028
                    ],
                    [
                        24.681509,
                        59.386029
                    ],
                    [
                        24.68151,
                        59.38603
                    ],
                    [
                        24.68157,
                        59.386055
                    ],
                    [
                        24.681695,
                        59.386106
                    ]
                ]
            ]
        }
    },
    "Lucky Luke": {
        "aadress": "Sadama 1",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.753915,
                        59.44733
                    ],
                    [
                        24.753905,
                        59.447407
                    ],
                    [
                        24.75379,
                        59.448248
                    ],
                    [
                        24.753508,
                        59.448238
                    ],
                    [
                        24.753515,
                        59.448181
                    ],
                    [
                        24.75356,
                        59.447857
                    ],
                    [
                        24.753622,
                        59.447397
                    ],
                    [
                        24.75363,
                        59.447336
                    ],
                    [
                        24.75359,
                        59.447335
                    ],
                    [
                        24.753604,
                        59.447233
                    ],
                    [
                        24.753262,
                        59.447221
                    ],
                    [
                        24.753248,
                        59.447323
                    ],
                    [
                        24.753207,
                        59.447321
                    ],
                    [
                        24.753199,
                        59.447382
                    ],
                    [
                        24.753136,
                        59.447842
                    ],
                    [
                        24.753092,
                        59.448166
                    ],
                    [
                        24.753084,
                        59.448223
                    ],
                    [
                        24.752802,
                        59.448213
                    ],
                    [
                        24.752917,
                        59.447372
                    ],
                    [
                        24.752927,
                        59.447296
                    ],
                    [
                        24.752942,
                        59.447185
                    ],
                    [
                        24.752042,
                        59.447153
                    ],
                    [
                        24.752083,
                        59.446851
                    ],
                    [
                        24.752236,
                        59.446856
                    ],
                    [
                        24.752309,
                        59.446322
                    ],
                    [
                        24.752156,
                        59.446317
                    ],
                    [
                        24.752197,
                        59.446014
                    ],
                    [
                        24.753104,
                        59.446046
                    ],
                    [
                        24.75328,
                        59.444752
                    ],
                    [
                        24.753298,
                        59.444621
                    ],
                    [
                        24.753738,
                        59.444637
                    ],
                    [
                        24.75372,
                        59.444768
                    ],
                    [
                        24.753821,
                        59.444771
                    ],
                    [
                        24.753839,
                        59.44464
                    ],
                    [
                        24.754279,
                        59.444656
                    ],
                    [
                        24.754261,
                        59.444787
                    ],
                    [
                        24.754085,
                        59.44608
                    ],
                    [
                        24.754992,
                        59.446112
                    ],
                    [
                        24.754951,
                        59.446415
                    ],
                    [
                        24.754791,
                        59.446409
                    ],
                    [
                        24.754718,
                        59.446944
                    ],
                    [
                        24.754878,
                        59.446949
                    ],
                    [
                        24.754837,
                        59.447252
                    ],
                    [
                        24.75393,
                        59.44722
                    ],
                    [
                        24.753915,
                        59.44733
                    ]
                ],
                [
                    [
                        24.753953,
                        59.446266
                    ],
                    [
                        24.754523,
                        59.446286
                    ],
                    [
                        24.75453,
                        59.446232
                    ],
                    [
                        24.754798,
                        59.446242
                    ],
                    [
                        24.754808,
                        59.446169
                    ],
                    [
                        24.753971,
                        59.446139
                    ],
                    [
                        24.753953,
                        59.446266
                    ]
                ],
                [
                    [
                        24.753832,
                        59.447154
                    ],
                    [
                        24.75467,
                        59.447183
                    ],
                    [
                        24.75468,
                        59.44711
                    ],
                    [
                        24.754412,
                        59.447101
                    ],
                    [
                        24.754419,
                        59.447047
                    ],
                    [
                        24.75385,
                        59.447027
                    ],
                    [
                        24.753832,
                        59.447154
                    ]
                ],
                [
                    [
                        24.753195,
                        59.446112
                    ],
                    [
                        24.752364,
                        59.446083
                    ],
                    [
                        24.752354,
                        59.446156
                    ],
                    [
                        24.752622,
                        59.446165
                    ],
                    [
                        24.752615,
                        59.446219
                    ],
                    [
                        24.753177,
                        59.446239
                    ],
                    [
                        24.753195,
                        59.446112
                    ]
                ],
                [
                    [
                        24.753074,
                        59.446999
                    ],
                    [
                        24.752511,
                        59.44698
                    ],
                    [
                        24.752504,
                        59.447033
                    ],
                    [
                        24.752236,
                        59.447024
                    ],
                    [
                        24.752226,
                        59.447097
                    ],
                    [
                        24.753057,
                        59.447126
                    ],
                    [
                        24.753074,
                        59.446999
                    ]
                ],
                [
                    [
                        24.753654,
                        59.446024
                    ],
                    [
                        24.753546,
                        59.446021
                    ],
                    [
                        24.753522,
                        59.446196
                    ],
                    [
                        24.75363,
                        59.4462
                    ],
                    [
                        24.753654,
                        59.446024
                    ]
                ]
            ]
        }
    },
    "Ööklubi Dekoltee": {
        "aadress": "Ahtri 10",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [[24.762635,59.438984],[24.762754,59.438989],[24.762739,59.439095],[24.762132,59.439073],[24.76221,59.438537],[24.762548,59.43855],[24.762547,59.438553],[24.762716,59.43856],[24.762708,59.438611],[24.762795,59.438615],[24.762748,59.438938],[24.762642,59.438934],[24.762635,59.438984]]
            ]
        }
    },
    "Ööklubi Hollywood": {
        "aadress": "Vana-Posti 8",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.74515,
                        59.435369
                    ],
                    [
                        24.745157,
                        59.435379
                    ],
                    [
                        24.745003,
                        59.435413
                    ],
                    [
                        24.744944,
                        59.43534
                    ],
                    [
                        24.744986,
                        59.435331
                    ],
                    [
                        24.744961,
                        59.435292
                    ],
                    [
                        24.74494,
                        59.435253
                    ],
                    [
                        24.74493,
                        59.435223
                    ],
                    [
                        24.744917,
                        59.43517
                    ],
                    [
                        24.744918,
                        59.435117
                    ],
                    [
                        24.744925,
                        59.435079
                    ],
                    [
                        24.744937,
                        59.435043
                    ],
                    [
                        24.744891,
                        59.435037
                    ],
                    [
                        24.744927,
                        59.434964
                    ],
                    [
                        24.745091,
                        59.434984
                    ],
                    [
                        24.745087,
                        59.434994
                    ],
                    [
                        24.745378,
                        59.43503
                    ],
                    [
                        24.745382,
                        59.435022
                    ],
                    [
                        24.745546,
                        59.435044
                    ],
                    [
                        24.745529,
                        59.435086
                    ],
                    [
                        24.745522,
                        59.435117
                    ],
                    [
                        24.745522,
                        59.435149
                    ],
                    [
                        24.745526,
                        59.435171
                    ],
                    [
                        24.745536,
                        59.435198
                    ],
                    [
                        24.745552,
                        59.435234
                    ],
                    [
                        24.745568,
                        59.435254
                    ],
                    [
                        24.745581,
                        59.43527
                    ],
                    [
                        24.74559,
                        59.43528
                    ],
                    [
                        24.745435,
                        59.435315
                    ],
                    [
                        24.745427,
                        59.435308
                    ],
                    [
                        24.74515,
                        59.435369
                    ]
                ]
            ]
        }
    },
    "Ööklubi Amigo/Viru Varietee/<br/>Stereobaar/Valuutabaar jt": {
        "aadress": "Viru väljak 4",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.755785,
                        59.436797
                    ],
                    [
                        24.755784,
                        59.436802
                    ],
                    [
                        24.75573,
                        59.4368
                    ],
                    [
                        24.755731,
                        59.436795
                    ],
                    [
                        24.755408,
                        59.436784
                    ],
                    [
                        24.755418,
                        59.436713
                    ],
                    [
                        24.755309,
                        59.436709
                    ],
                    [
                        24.755299,
                        59.43678
                    ],
                    [
                        24.754968,
                        59.436768
                    ],
                    [
                        24.754822,
                        59.436763
                    ],
                    [
                        24.754491,
                        59.436751
                    ],
                    [
                        24.754505,
                        59.436646
                    ],
                    [
                        24.754479,
                        59.436645
                    ],
                    [
                        24.754483,
                        59.436617
                    ],
                    [
                        24.754489,
                        59.436617
                    ],
                    [
                        24.754519,
                        59.436545
                    ],
                    [
                        24.754525,
                        59.4365
                    ],
                    [
                        24.754515,
                        59.436426
                    ],
                    [
                        24.754509,
                        59.436426
                    ],
                    [
                        24.754513,
                        59.436398
                    ],
                    [
                        24.754538,
                        59.436399
                    ],
                    [
                        24.754555,
                        59.436278
                    ],
                    [
                        24.754574,
                        59.436137
                    ],
                    [
                        24.754638,
                        59.435663
                    ],
                    [
                        24.754641,
                        59.435643
                    ],
                    [
                        24.755454,
                        59.435672
                    ],
                    [
                        24.755451,
                        59.435692
                    ],
                    [
                        24.755498,
                        59.435693
                    ],
                    [
                        24.755498,
                        59.435687
                    ],
                    [
                        24.755505,
                        59.435676
                    ],
                    [
                        24.755519,
                        59.435668
                    ],
                    [
                        24.755538,
                        59.435662
                    ],
                    [
                        24.75556,
                        59.43566
                    ],
                    [
                        24.755581,
                        59.435662
                    ],
                    [
                        24.7556,
                        59.435667
                    ],
                    [
                        24.755615,
                        59.435676
                    ],
                    [
                        24.755628,
                        59.435676
                    ],
                    [
                        24.755633,
                        59.435639
                    ],
                    [
                        24.756078,
                        59.435655
                    ],
                    [
                        24.756015,
                        59.436117
                    ],
                    [
                        24.756024,
                        59.436117
                    ],
                    [
                        24.756015,
                        59.436187
                    ],
                    [
                        24.755868,
                        59.436181
                    ],
                    [
                        24.755785,
                        59.436797
                    ]
                ]
            ]
        }
    },
    "Nõmme kultuurikeskus ": {
        "aadress": "Turu plats 2",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.68463,
                        59.388362
                    ],
                    [
                        24.684516,
                        59.388344
                    ],
                    [
                        24.684208,
                        59.388298
                    ],
                    [
                        24.68391,
                        59.388249
                    ],
                    [
                        24.683942,
                        59.388212
                    ],
                    [
                        24.68395,
                        59.388213
                    ],
                    [
                        24.683963,
                        59.388199
                    ],
                    [
                        24.68396,
                        59.388198
                    ],
                    [
                        24.684057,
                        59.388085
                    ],
                    [
                        24.684748,
                        59.388234
                    ],
                    [
                        24.684666,
                        59.388334
                    ],
                    [
                        24.684654,
                        59.388331
                    ],
                    [
                        24.68463,
                        59.388362
                    ]
                ]
            ]
        }
    },
    "Ööklubi Othello": {
        "aadress": "Vilde tee 122",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.664991,
                        59.404127
                    ],
                    [
                        24.66375,
                        59.403972
                    ],
                    [
                        24.663805,
                        59.403859
                    ],
                    [
                        24.664823,
                        59.403985
                    ],
                    [
                        24.664974,
                        59.403669
                    ],
                    [
                        24.665198,
                        59.403697
                    ],
                    [
                        24.665173,
                        59.403749
                    ],
                    [
                        24.665276,
                        59.403761
                    ],
                    [
                        24.665176,
                        59.403974
                    ],
                    [
                        24.665153,
                        59.404023
                    ],
                    [
                        24.665047,
                        59.404009
                    ],
                    [
                        24.664991,
                        59.404127
                    ]
                ]
            ]
        }
    },
    "Restoran Szolnok": {
        "aadress": "Vilde tee 101",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.675786,
                        59.404547
                    ],
                    [
                        24.675845,
                        59.404498
                    ],
                    [
                        24.675851,
                        59.404484
                    ],
                    [
                        24.675817,
                        59.40448
                    ],
                    [
                        24.675932,
                        59.404231
                    ],
                    [
                        24.675964,
                        59.404161
                    ],
                    [
                        24.676622,
                        59.40424
                    ],
                    [
                        24.67659,
                        59.40431
                    ],
                    [
                        24.676569,
                        59.404356
                    ],
                    [
                        24.676297,
                        59.404522
                    ],
                    [
                        24.676266,
                        59.404587
                    ],
                    [
                        24.675989,
                        59.404554
                    ],
                    [
                        24.675981,
                        59.40457
                    ],
                    [
                        24.675786,
                        59.404547
                    ]
                ]
            ]
        }
    },
    "Restoran Kännu Kukk": {
        "aadress": "Vilde tee 71a",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.687061,
                        59.4029
                    ],
                    [
                        24.687205,
                        59.402607
                    ],
                    [
                        24.687392,
                        59.402629
                    ],
                    [
                        24.68737,
                        59.402677
                    ],
                    [
                        24.687434,
                        59.402685
                    ],
                    [
                        24.687444,
                        59.402697
                    ],
                    [
                        24.687423,
                        59.402734
                    ],
                    [
                        24.687704,
                        59.40277
                    ],
                    [
                        24.687724,
                        59.402732
                    ],
                    [
                        24.68779,
                        59.402739
                    ],
                    [
                        24.687678,
                        59.402965
                    ],
                    [
                        24.687061,
                        59.4029
                    ]
                ]
            ]
        }
    },
    "Von Krahli baar": {
        "aadress": "Rataskaevu 10",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.742876,
                        59.437217
                    ],
                    [
                        24.742593,
                        59.437257
                    ],
                    [
                        24.742596,
                        59.437262
                    ],
                    [
                        24.742511,
                        59.437276
                    ],
                    [
                        24.742514,
                        59.437279
                    ],
                    [
                        24.742374,
                        59.437303
                    ],
                    [
                        24.742213,
                        59.437167
                    ],
                    [
                        24.74238,
                        59.437124
                    ],
                    [
                        24.742388,
                        59.437133
                    ],
                    [
                        24.742749,
                        59.437053
                    ],
                    [
                        24.742876,
                        59.437217
                    ]
                ],
                [
                    [
                        24.742418,
                        59.437168
                    ],
                    [
                        24.742449,
                        59.437203
                    ],
                    [
                        24.742624,
                        59.437175
                    ],
                    [
                        24.742608,
                        59.437152
                    ],
                    [
                        24.742598,
                        59.437138
                    ],
                    [
                        24.742448,
                        59.437163
                    ],
                    [
                        24.742418,
                        59.437168
                    ]
                ]
            ]
        }
    },
    "Restoran Eeslitall": {
        "aadress": "Dunkri 5",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.744389,
                        59.436897
                    ],
                    [
                        24.744386,
                        59.436905
                    ],
                    [
                        24.744374,
                        59.43693
                    ],
                    [
                        24.744371,
                        59.436952
                    ],
                    [
                        24.74437,
                        59.436993
                    ],
                    [
                        24.74437,
                        59.437018
                    ],
                    [
                        24.744286,
                        59.437014
                    ],
                    [
                        24.743794,
                        59.436946
                    ],
                    [
                        24.743796,
                        59.436939
                    ],
                    [
                        24.743573,
                        59.436913
                    ],
                    [
                        24.743583,
                        59.436901
                    ],
                    [
                        24.743169,
                        59.436818
                    ],
                    [
                        24.743186,
                        59.436786
                    ],
                    [
                        24.743304,
                        59.436802
                    ],
                    [
                        24.743361,
                        59.436684
                    ],
                    [
                        24.743349,
                        59.436683
                    ],
                    [
                        24.743361,
                        59.436657
                    ],
                    [
                        24.743475,
                        59.436671
                    ],
                    [
                        24.743502,
                        59.436605
                    ],
                    [
                        24.743958,
                        59.436625
                    ],
                    [
                        24.744018,
                        59.436633
                    ],
                    [
                        24.743978,
                        59.436714
                    ],
                    [
                        24.744345,
                        59.436761
                    ],
                    [
                        24.744389,
                        59.436897
                    ]
                ]
            ]
        }
    },
    "Mündi baar": {
        "aadress": "Mündi 3",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.745141,
                        59.437839
                    ],
                    [
                        24.745059,
                        59.438001
                    ],
                    [
                        24.7448,
                        59.437943
                    ],
                    [
                        24.744658,
                        59.437911
                    ],
                    [
                        24.744661,
                        59.437906
                    ],
                    [
                        24.744741,
                        59.437803
                    ],
                    [
                        24.744485,
                        59.437765
                    ],
                    [
                        24.744533,
                        59.437609
                    ],
                    [
                        24.745216,
                        59.437652
                    ],
                    [
                        24.745173,
                        59.437774
                    ],
                    [
                        24.745141,
                        59.437839
                    ]
                ],
                [
                    [
                        24.744773,
                        59.437764
                    ],
                    [
                        24.744907,
                        59.437791
                    ],
                    [
                        24.744921,
                        59.437742
                    ],
                    [
                        24.744886,
                        59.43774
                    ],
                    [
                        24.744891,
                        59.437717
                    ],
                    [
                        24.744785,
                        59.437711
                    ],
                    [
                        24.744773,
                        59.437764
                    ]
                ]
            ]
        }
    },
    "Karika baar": {
        "aadress": "Kuninga 3",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.745509,
                        59.436219
                    ],
                    [
                        24.745675,
                        59.436409
                    ],
                    [
                        24.745466,
                        59.436413
                    ],
                    [
                        24.745437,
                        59.43641
                    ],
                    [
                        24.745399,
                        59.436309
                    ],
                    [
                        24.745418,
                        59.436307
                    ],
                    [
                        24.745361,
                        59.436246
                    ],
                    [
                        24.745421,
                        59.436235
                    ],
                    [
                        24.745347,
                        59.436141
                    ],
                    [
                        24.745285,
                        59.436152
                    ],
                    [
                        24.745268,
                        59.436135
                    ],
                    [
                        24.74521,
                        59.436078
                    ],
                    [
                        24.745323,
                        59.436056
                    ],
                    [
                        24.745509,
                        59.436219
                    ]
                ]
            ]
        }
    },
    "Pubi Guitar Safari <br/>(nüüd ööklubi Münt, <br/>endine Valguse Baar)": {
        "aadress": "Müürivahe 22",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.747951,
                        59.435377
                    ],
                    [
                        24.747835,
                        59.435453
                    ],
                    [
                        24.747755,
                        59.435506
                    ],
                    [
                        24.747703,
                        59.435511
                    ],
                    [
                        24.747286,
                        59.435373
                    ],
                    [
                        24.747335,
                        59.435329
                    ],
                    [
                        24.747258,
                        59.435306
                    ],
                    [
                        24.747313,
                        59.435256
                    ],
                    [
                        24.747361,
                        59.435214
                    ],
                    [
                        24.747378,
                        59.43522
                    ],
                    [
                        24.747401,
                        59.435202
                    ],
                    [
                        24.747749,
                        59.43531
                    ],
                    [
                        24.74781,
                        59.435273
                    ],
                    [
                        24.747739,
                        59.435249
                    ],
                    [
                        24.747611,
                        59.435195
                    ],
                    [
                        24.747459,
                        59.435105
                    ],
                    [
                        24.747409,
                        59.435064
                    ],
                    [
                        24.747365,
                        59.435077
                    ],
                    [
                        24.747343,
                        59.435093
                    ],
                    [
                        24.74733,
                        59.435102
                    ],
                    [
                        24.747215,
                        59.435061
                    ],
                    [
                        24.747228,
                        59.435051
                    ],
                    [
                        24.747253,
                        59.43503
                    ],
                    [
                        24.747189,
                        59.434966
                    ],
                    [
                        24.747728,
                        59.434819
                    ],
                    [
                        24.747742,
                        59.434818
                    ],
                    [
                        24.747768,
                        59.434819
                    ],
                    [
                        24.747786,
                        59.434824
                    ],
                    [
                        24.747986,
                        59.434932
                    ],
                    [
                        24.748319,
                        59.435118
                    ],
                    [
                        24.748327,
                        59.435128
                    ],
                    [
                        24.748327,
                        59.435136
                    ],
                    [
                        24.748317,
                        59.435147
                    ],
                    [
                        24.747951,
                        59.435377
                    ]
                ],
                [
                    [
                        24.747732,
                        59.435116
                    ],
                    [
                        24.747871,
                        59.435177
                    ],
                    [
                        24.747819,
                        59.435206
                    ],
                    [
                        24.74785,
                        59.435217
                    ],
                    [
                        24.74787,
                        59.435224
                    ],
                    [
                        24.747994,
                        59.435148
                    ],
                    [
                        24.748,
                        59.435151
                    ],
                    [
                        24.748007,
                        59.435153
                    ],
                    [
                        24.748016,
                        59.435154
                    ],
                    [
                        24.748024,
                        59.435153
                    ],
                    [
                        24.748032,
                        59.43515
                    ],
                    [
                        24.748037,
                        59.435147
                    ],
                    [
                        24.74804,
                        59.435142
                    ],
                    [
                        24.748039,
                        59.435138
                    ],
                    [
                        24.748036,
                        59.435134
                    ],
                    [
                        24.74803,
                        59.435131
                    ],
                    [
                        24.748023,
                        59.435129
                    ],
                    [
                        24.748014,
                        59.435128
                    ],
                    [
                        24.748005,
                        59.435129
                    ],
                    [
                        24.747998,
                        59.435131
                    ],
                    [
                        24.747993,
                        59.435134
                    ],
                    [
                        24.747893,
                        59.43508
                    ],
                    [
                        24.747876,
                        59.435089
                    ],
                    [
                        24.747863,
                        59.435091
                    ],
                    [
                        24.747849,
                        59.435091
                    ],
                    [
                        24.747831,
                        59.435089
                    ],
                    [
                        24.747815,
                        59.435084
                    ],
                    [
                        24.747804,
                        59.435077
                    ],
                    [
                        24.747798,
                        59.435068
                    ],
                    [
                        24.747798,
                        59.435058
                    ],
                    [
                        24.747804,
                        59.43505
                    ],
                    [
                        24.747821,
                        59.435041
                    ],
                    [
                        24.747725,
                        59.434989
                    ],
                    [
                        24.74773,
                        59.434975
                    ],
                    [
                        24.747726,
                        59.434962
                    ],
                    [
                        24.747717,
                        59.434959
                    ],
                    [
                        24.747705,
                        59.434958
                    ],
                    [
                        24.747693,
                        59.434958
                    ],
                    [
                        24.747683,
                        59.434961
                    ],
                    [
                        24.747674,
                        59.434969
                    ],
                    [
                        24.747675,
                        59.434974
                    ],
                    [
                        24.747686,
                        59.434991
                    ],
                    [
                        24.747507,
                        59.435034
                    ],
                    [
                        24.74754,
                        59.435066
                    ],
                    [
                        24.747602,
                        59.435036
                    ],
                    [
                        24.747732,
                        59.435116
                    ]
                ]
            ]
        }
    },
    "Ööklubi Veenus <br/>(endine Bel-Air)": {
        "aadress": "Vana-Viru 14",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.752548,
                        59.437166
                    ],
                    [
                        24.752464,
                        59.437174
                    ],
                    [
                        24.752474,
                        59.437202
                    ],
                    [
                        24.751996,
                        59.437242
                    ],
                    [
                        24.752002,
                        59.437206
                    ],
                    [
                        24.752023,
                        59.43708
                    ],
                    [
                        24.752027,
                        59.437052
                    ],
                    [
                        24.752161,
                        59.437056
                    ],
                    [
                        24.752175,
                        59.437097
                    ],
                    [
                        24.752396,
                        59.437077
                    ],
                    [
                        24.752356,
                        59.436965
                    ],
                    [
                        24.752393,
                        59.436962
                    ],
                    [
                        24.752377,
                        59.436919
                    ],
                    [
                        24.752418,
                        59.436915
                    ],
                    [
                        24.752394,
                        59.436849
                    ],
                    [
                        24.752645,
                        59.436826
                    ],
                    [
                        24.752665,
                        59.436824
                    ],
                    [
                        24.75269,
                        59.436895
                    ],
                    [
                        24.752671,
                        59.436897
                    ],
                    [
                        24.752737,
                        59.437085
                    ],
                    [
                        24.752756,
                        59.437083
                    ],
                    [
                        24.752781,
                        59.437153
                    ],
                    [
                        24.752717,
                        59.437159
                    ],
                    [
                        24.752648,
                        59.437165
                    ],
                    [
                        24.752645,
                        59.437157
                    ],
                    [
                        24.752548,
                        59.437166
                    ]
                ]
            ]
        }
    },
    "Ööklubi Nightman": {
        "aadress": "Vineeri 4",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.744377,
                        59.423174
                    ],
                    [
                        24.744374,
                        59.423219
                    ],
                    [
                        24.744366,
                        59.423349
                    ],
                    [
                        24.744173,
                        59.423349
                    ],
                    [
                        24.744171,
                        59.423175
                    ],
                    [
                        24.744377,
                        59.423174
                    ]
                ]
            ]
        }
    },
    "Ööklubi Angel <br/>(nüüd ööklubi Studio)": {
        "aadress": "Sauna 1",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.747966,
                        59.436121
                    ],
                    [
                        24.747802,
                        59.436181
                    ],
                    [
                        24.747787,
                        59.436173
                    ],
                    [
                        24.747591,
                        59.436093
                    ],
                    [
                        24.747553,
                        59.436095
                    ],
                    [
                        24.747529,
                        59.436086
                    ],
                    [
                        24.747525,
                        59.436066
                    ],
                    [
                        24.747461,
                        59.43604
                    ],
                    [
                        24.747399,
                        59.436044
                    ],
                    [
                        24.747393,
                        59.436012
                    ],
                    [
                        24.747386,
                        59.43601
                    ],
                    [
                        24.747378,
                        59.435931
                    ],
                    [
                        24.747353,
                        59.435918
                    ],
                    [
                        24.747231,
                        59.435918
                    ],
                    [
                        24.747221,
                        59.435921
                    ],
                    [
                        24.747224,
                        59.435969
                    ],
                    [
                        24.74715,
                        59.43597
                    ],
                    [
                        24.747103,
                        59.435954
                    ],
                    [
                        24.747002,
                        59.436019
                    ],
                    [
                        24.746986,
                        59.436011
                    ],
                    [
                        24.746957,
                        59.436032
                    ],
                    [
                        24.747059,
                        59.436066
                    ],
                    [
                        24.747062,
                        59.436077
                    ],
                    [
                        24.746968,
                        59.43616
                    ],
                    [
                        24.746946,
                        59.43618
                    ],
                    [
                        24.74692,
                        59.436173
                    ],
                    [
                        24.74659,
                        59.436084
                    ],
                    [
                        24.746801,
                        59.435937
                    ],
                    [
                        24.746993,
                        59.435836
                    ],
                    [
                        24.747249,
                        59.435742
                    ],
                    [
                        24.747289,
                        59.435735
                    ],
                    [
                        24.747315,
                        59.435734
                    ],
                    [
                        24.747337,
                        59.435735
                    ],
                    [
                        24.74736,
                        59.435742
                    ],
                    [
                        24.747387,
                        59.435756
                    ],
                    [
                        24.747482,
                        59.435817
                    ],
                    [
                        24.747475,
                        59.435819
                    ],
                    [
                        24.747555,
                        59.435876
                    ],
                    [
                        24.747558,
                        59.435874
                    ],
                    [
                        24.747744,
                        59.436005
                    ],
                    [
                        24.747966,
                        59.436121
                    ]
                ]
            ]
        }
    },
    "Ööklubi Bonnie and Clyde": {
        "aadress": "Liivalaia 33",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.757916,
                        59.430189
                    ],
                    [
                        24.757988,
                        59.430219
                    ],
                    [
                        24.757959,
                        59.430237
                    ],
                    [
                        24.757998,
                        59.430254
                    ],
                    [
                        24.757967,
                        59.430274
                    ],
                    [
                        24.757981,
                        59.43028
                    ],
                    [
                        24.758043,
                        59.43024
                    ],
                    [
                        24.758088,
                        59.430259
                    ],
                    [
                        24.758155,
                        59.430216
                    ],
                    [
                        24.758754,
                        59.43046
                    ],
                    [
                        24.758689,
                        59.430501
                    ],
                    [
                        24.758727,
                        59.430517
                    ],
                    [
                        24.758583,
                        59.430608
                    ],
                    [
                        24.758545,
                        59.430593
                    ],
                    [
                        24.758492,
                        59.430627
                    ],
                    [
                        24.758529,
                        59.430642
                    ],
                    [
                        24.758384,
                        59.430734
                    ],
                    [
                        24.758347,
                        59.430719
                    ],
                    [
                        24.758312,
                        59.430741
                    ],
                    [
                        24.757737,
                        59.430506
                    ],
                    [
                        24.757705,
                        59.430526
                    ],
                    [
                        24.757186,
                        59.430314
                    ],
                    [
                        24.757217,
                        59.430294
                    ],
                    [
                        24.756898,
                        59.430163
                    ],
                    [
                        24.75683,
                        59.430207
                    ],
                    [
                        24.75676,
                        59.430178
                    ],
                    [
                        24.756828,
                        59.430135
                    ],
                    [
                        24.756642,
                        59.430059
                    ],
                    [
                        24.756677,
                        59.430037
                    ],
                    [
                        24.756634,
                        59.430019
                    ],
                    [
                        24.756779,
                        59.429927
                    ],
                    [
                        24.756822,
                        59.429945
                    ],
                    [
                        24.756876,
                        59.429911
                    ],
                    [
                        24.756833,
                        59.429893
                    ],
                    [
                        24.756976,
                        59.429802
                    ],
                    [
                        24.757019,
                        59.429819
                    ],
                    [
                        24.757049,
                        59.4298
                    ],
                    [
                        24.757643,
                        59.430043
                    ],
                    [
                        24.757613,
                        59.430062
                    ],
                    [
                        24.757648,
                        59.430076
                    ],
                    [
                        24.757583,
                        59.430117
                    ],
                    [
                        24.757612,
                        59.430129
                    ],
                    [
                        24.757644,
                        59.430109
                    ],
                    [
                        24.757684,
                        59.430125
                    ],
                    [
                        24.757713,
                        59.430106
                    ],
                    [
                        24.757772,
                        59.43013
                    ],
                    [
                        24.757916,
                        59.430189
                    ]
                ]
            ]
        }
    },
    "Ööklubi Bon Bon": {
        "aadress": "Vana Posti 8",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.74515,
                        59.435369
                    ],
                    [
                        24.745157,
                        59.435379
                    ],
                    [
                        24.745003,
                        59.435413
                    ],
                    [
                        24.744944,
                        59.43534
                    ],
                    [
                        24.744986,
                        59.435331
                    ],
                    [
                        24.744961,
                        59.435292
                    ],
                    [
                        24.74494,
                        59.435253
                    ],
                    [
                        24.74493,
                        59.435223
                    ],
                    [
                        24.744917,
                        59.43517
                    ],
                    [
                        24.744918,
                        59.435117
                    ],
                    [
                        24.744925,
                        59.435079
                    ],
                    [
                        24.744937,
                        59.435043
                    ],
                    [
                        24.744891,
                        59.435037
                    ],
                    [
                        24.744927,
                        59.434964
                    ],
                    [
                        24.745091,
                        59.434984
                    ],
                    [
                        24.745087,
                        59.434994
                    ],
                    [
                        24.745378,
                        59.43503
                    ],
                    [
                        24.745382,
                        59.435022
                    ],
                    [
                        24.745546,
                        59.435044
                    ],
                    [
                        24.745529,
                        59.435086
                    ],
                    [
                        24.745522,
                        59.435117
                    ],
                    [
                        24.745522,
                        59.435149
                    ],
                    [
                        24.745526,
                        59.435171
                    ],
                    [
                        24.745536,
                        59.435198
                    ],
                    [
                        24.745552,
                        59.435234
                    ],
                    [
                        24.745568,
                        59.435254
                    ],
                    [
                        24.745581,
                        59.43527
                    ],
                    [
                        24.74559,
                        59.43528
                    ],
                    [
                        24.745435,
                        59.435315
                    ],
                    [
                        24.745427,
                        59.435308
                    ],
                    [
                        24.74515,
                        59.435369
                    ]
                ]
            ]
        }
    },
    "Ööklubi Spirit": {
        "aadress": "Mere puiestee 6e",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.754373,
                        59.439952
                    ],
                    [
                        24.754092,
                        59.439942
                    ],
                    [
                        24.754204,
                        59.439104
                    ],
                    [
                        24.754365,
                        59.439109
                    ],
                    [
                        24.754519,
                        59.439115
                    ],
                    [
                        24.754516,
                        59.439134
                    ],
                    [
                        24.754615,
                        59.439136
                    ],
                    [
                        24.754612,
                        59.439179
                    ],
                    [
                        24.754644,
                        59.439181
                    ],
                    [
                        24.75464,
                        59.439208
                    ],
                    [
                        24.754584,
                        59.439206
                    ],
                    [
                        24.754587,
                        59.439183
                    ],
                    [
                        24.75451,
                        59.439181
                    ],
                    [
                        24.754486,
                        59.439357
                    ],
                    [
                        24.754453,
                        59.439356
                    ],
                    [
                        24.754373,
                        59.439952
                    ]
                ]
            ]
        }
    },
    "Ööklubi Chill Out/<br/>Ehast Koiduni": {
        "aadress": "Roosikrantsi 3",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.743816,
                        59.432295
                    ],
                    [
                        24.743826,
                        59.43234
                    ],
                    [
                        24.743807,
                        59.432352
                    ],
                    [
                        24.743799,
                        59.432352
                    ],
                    [
                        24.743819,
                        59.432433
                    ],
                    [
                        24.743586,
                        59.43244
                    ],
                    [
                        24.743587,
                        59.432447
                    ],
                    [
                        24.743552,
                        59.432449
                    ],
                    [
                        24.743508,
                        59.432264
                    ],
                    [
                        24.743751,
                        59.432249
                    ],
                    [
                        24.74376,
                        59.432288
                    ],
                    [
                        24.743792,
                        59.432286
                    ],
                    [
                        24.743816,
                        59.432295
                    ]
                ]
            ]
        }
    },
    "Regati baar": {
        "aadress": "Merivälja tee 1",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.832187,
                        59.466932
                    ],
                    [
                        24.832139,
                        59.466957
                    ],
                    [
                        24.832122,
                        59.466964
                    ],
                    [
                        24.832104,
                        59.466969
                    ],
                    [
                        24.832085,
                        59.466972
                    ],
                    [
                        24.83207,
                        59.466973
                    ],
                    [
                        24.832055,
                        59.466973
                    ],
                    [
                        24.832037,
                        59.466972
                    ],
                    [
                        24.83202,
                        59.466969
                    ],
                    [
                        24.832007,
                        59.466965
                    ],
                    [
                        24.831994,
                        59.466961
                    ],
                    [
                        24.831982,
                        59.466954
                    ],
                    [
                        24.831972,
                        59.466947
                    ],
                    [
                        24.831964,
                        59.466939
                    ],
                    [
                        24.831959,
                        59.46693
                    ],
                    [
                        24.831957,
                        59.46692
                    ],
                    [
                        24.831958,
                        59.466913
                    ],
                    [
                        24.831963,
                        59.466903
                    ],
                    [
                        24.831969,
                        59.466895
                    ],
                    [
                        24.831977,
                        59.466889
                    ],
                    [
                        24.831985,
                        59.466884
                    ],
                    [
                        24.831925,
                        59.466853
                    ],
                    [
                        24.832152,
                        59.466737
                    ],
                    [
                        24.832125,
                        59.466723
                    ],
                    [
                        24.832291,
                        59.466638
                    ],
                    [
                        24.832319,
                        59.466652
                    ],
                    [
                        24.83257,
                        59.466523
                    ],
                    [
                        24.832628,
                        59.466549
                    ],
                    [
                        24.832679,
                        59.466533
                    ],
                    [
                        24.832694,
                        59.466532
                    ],
                    [
                        24.832723,
                        59.466531
                    ],
                    [
                        24.832739,
                        59.466533
                    ],
                    [
                        24.832762,
                        59.466536
                    ],
                    [
                        24.832779,
                        59.466542
                    ],
                    [
                        24.8328,
                        59.466552
                    ],
                    [
                        24.832817,
                        59.466565
                    ],
                    [
                        24.832824,
                        59.466572
                    ],
                    [
                        24.832828,
                        59.466578
                    ],
                    [
                        24.832829,
                        59.466591
                    ],
                    [
                        24.832828,
                        59.4666
                    ],
                    [
                        24.832822,
                        59.466609
                    ],
                    [
                        24.832814,
                        59.466618
                    ],
                    [
                        24.832804,
                        59.466628
                    ],
                    [
                        24.832791,
                        59.466634
                    ],
                    [
                        24.83252,
                        59.46677
                    ],
                    [
                        24.832488,
                        59.466786
                    ],
                    [
                        24.832497,
                        59.466789
                    ],
                    [
                        24.832324,
                        59.466878
                    ],
                    [
                        24.832308,
                        59.466871
                    ],
                    [
                        24.832187,
                        59.466932
                    ]
                ]
            ]
        }
    },
    "Karja Kelder": {
        "aadress": "Väike Karja 1",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.747966,
                        59.436121
                    ],
                    [
                        24.747802,
                        59.436181
                    ],
                    [
                        24.747787,
                        59.436173
                    ],
                    [
                        24.747591,
                        59.436093
                    ],
                    [
                        24.747553,
                        59.436095
                    ],
                    [
                        24.747529,
                        59.436086
                    ],
                    [
                        24.747525,
                        59.436066
                    ],
                    [
                        24.747461,
                        59.43604
                    ],
                    [
                        24.747399,
                        59.436044
                    ],
                    [
                        24.747393,
                        59.436012
                    ],
                    [
                        24.747386,
                        59.43601
                    ],
                    [
                        24.747378,
                        59.435931
                    ],
                    [
                        24.747353,
                        59.435918
                    ],
                    [
                        24.747231,
                        59.435918
                    ],
                    [
                        24.747221,
                        59.435921
                    ],
                    [
                        24.747224,
                        59.435969
                    ],
                    [
                        24.74715,
                        59.43597
                    ],
                    [
                        24.747103,
                        59.435954
                    ],
                    [
                        24.747002,
                        59.436019
                    ],
                    [
                        24.746986,
                        59.436011
                    ],
                    [
                        24.746957,
                        59.436032
                    ],
                    [
                        24.747059,
                        59.436066
                    ],
                    [
                        24.747062,
                        59.436077
                    ],
                    [
                        24.746968,
                        59.43616
                    ],
                    [
                        24.746946,
                        59.43618
                    ],
                    [
                        24.74692,
                        59.436173
                    ],
                    [
                        24.74659,
                        59.436084
                    ],
                    [
                        24.746801,
                        59.435937
                    ],
                    [
                        24.746993,
                        59.435836
                    ],
                    [
                        24.747249,
                        59.435742
                    ],
                    [
                        24.747289,
                        59.435735
                    ],
                    [
                        24.747315,
                        59.435734
                    ],
                    [
                        24.747337,
                        59.435735
                    ],
                    [
                        24.74736,
                        59.435742
                    ],
                    [
                        24.747387,
                        59.435756
                    ],
                    [
                        24.747482,
                        59.435817
                    ],
                    [
                        24.747475,
                        59.435819
                    ],
                    [
                        24.747555,
                        59.435876
                    ],
                    [
                        24.747558,
                        59.435874
                    ],
                    [
                        24.747744,
                        59.436005
                    ],
                    [
                        24.747966,
                        59.436121
                    ]
                ]
            ]
        }
    },
    "Ööklubi Piraat": {
        "aadress": "Purje 8",
        "geoJSON": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        24.826191,
                        59.465883
                    ],
                    [
                        24.825555,
                        59.465485
                    ],
                    [
                        24.825637,
                        59.465448
                    ],
                    [
                        24.825618,
                        59.465432
                    ],
                    [
                        24.825826,
                        59.465349
                    ],
                    [
                        24.826067,
                        59.465501
                    ],
                    [
                        24.826133,
                        59.465474
                    ],
                    [
                        24.826095,
                        59.465449
                    ],
                    [
                        24.826168,
                        59.465419
                    ],
                    [
                        24.826353,
                        59.465528
                    ],
                    [
                        24.826389,
                        59.465511
                    ],
                    [
                        24.826343,
                        59.465485
                    ],
                    [
                        24.826409,
                        59.465456
                    ],
                    [
                        24.826589,
                        59.465563
                    ],
                    [
                        24.826611,
                        59.465552
                    ],
                    [
                        24.826574,
                        59.465523
                    ],
                    [
                        24.826642,
                        59.465495
                    ],
                    [
                        24.826827,
                        59.465606
                    ],
                    [
                        24.826863,
                        59.465592
                    ],
                    [
                        24.826814,
                        59.465561
                    ],
                    [
                        24.826876,
                        59.465534
                    ],
                    [
                        24.827021,
                        59.465625
                    ],
                    [
                        24.82636,
                        59.465894
                    ],
                    [
                        24.82628,
                        59.465845
                    ],
                    [
                        24.826191,
                        59.465883
                    ]
                ]
            ]
        }
    }
};

/*export const asutusedData2 = [
	["Mefisto baar", "Sakala 11"],
	["Silva baar", "Raudtee 64"],
	["Lucky Luke", "Sadama 1"],
	["Ööklubi Dekoltee", "Ahtri 10"],
	["Ööklubi Hollywood", "Vana-Posti 8"],
	["Ööklubi Amigo/Viru Varietee/Stereobaar/Valuutabaar jt", "Viru väljak 4"],
	["Nõmme kultuurikeskus ", "Turu plats 2"],
	["326", "Pärnu mnt. 326"],
	["Ööklubi Othello", "Vilde tee 122"],
	["Restoran Szolnok", "Vilde tee 101"],
	["Restoran Kännu Kukk", "Vilde tee 71a"],
	["Von Krahli baar", "Rataskaevu 10"],
	["Restoran Eeslitall", "Dunkri 5"],
	["Mündi baar", "Mündi 3"],
	["Karika baar", "Kuninga 3"],
	[
		"Pubi Guitar Safari (nüüd ööklubi Münt, endine Valguse Baar)",
		"Müürivahe 22",
	],
	["Ööklubi Veenus (endine Bel-Air)", "Vana-Viru 14"],
	["Ööklubi Nightman", "Vineeri 4"],
	["Ööklubi Angel (nüüd ööklubi Studio)", "Sauna 1"],
	["Ööklubi Bonnie and Clyde", "Liivalaia 33"],
	["Ööklubi Bon Bon", "Vana Posti 8"],
	["Ööklubi Spirit", "Mere puiestee 6e"],
	["Ööklubi Chill Out/Ehast Koiduni", "Roosikrantsi 3"],
	["Regati baar", "Merivälja tee 1"],
	["Karja Kelder", "Väike Karja 1"],
	["Ööklubi Piraat", "Purje 8"],
];*/
